import {OnDestroy} from "@angular/core";
import {Subscription} from "rxjs";

export abstract class LifecycleHandlerComponent implements OnDestroy {
  protected subscriptions = new Array<Subscription>();

  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
  }
}
